
import { observable, action, runInAction } from 'mobx';
import { RootStore } from '.';
import { NotificationLevel } from './NotificationStore';

export interface PagedList<T> {
    pageCount: number;
    totalItemCount: number;
    pageSize: number;
    pageNumber: number;
    isLastPage: boolean;
    hasNextPage: boolean;
    items: T[]
}

export class CommonStore {
    _rootStore: RootStore;
    _window: Window;

    constructor(rootStore: RootStore, window: Window) {
        this._rootStore = rootStore;
        this._window = window
    }

    @observable appName = "ProductMatrix";
    @observable currentPageName = "Page";
    @observable overlayIsVisible = false;
    @observable overlayMessage = "";
    @observable overlayStack = 0;
    scrollCallback?: () => void = undefined;

    @action setPageName(name: string) {
        this.currentPageName = name;
    }

    @action hideOverlay = (hideAfter = 0): void => {
        this.overlayStack--;
        this.overlayStack = this.overlayStack < 0 ? 0 : this.overlayStack;

        setTimeout(() => {
            if (this.overlayStack <= 0)
                runInAction(() =>
                    this.overlayIsVisible = false)
        }, hideAfter);
    };

    @action showOverlay = (message: string, showAfter = 0): void => {

        this.overlayStack++;
        this.overlayMessage = message;

        setTimeout(() => {
            if (this.overlayStack > 0)
                runInAction(() =>
                    this.overlayIsVisible = true)
        }, showAfter);
    };

    notifyWarning(message: string) {
        this._rootStore.notificationStore.addNotification(message, NotificationLevel.warning, 5);
    }
    notifyInfo(message: string) {
        this._rootStore.notificationStore.addNotification(message, NotificationLevel.info, 2);
    }

    notifyError(message: string) {
        this._rootStore.notificationStore.addNotification(message, NotificationLevel.error, 10);
    }

    initScrollTop(callback: () => void) {
        this.scrollCallback = callback;
    }

    scrollTop() {
        this._window.scrollTo(0, 0);
        if (this.scrollCallback != undefined)
            this.scrollCallback();
    }
}